import { render, staticRenderFns } from "./OrderFormTa.vue?vue&type=template&id=6053354a&"
import script from "./OrderFormTa.vue?vue&type=script&lang=js&"
export * from "./OrderFormTa.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormTa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports